import nodeContentRenderer from './CustomThemeNodeContentRenderer';

export default ({ nodeContentRenderer });
